import Reveal from "@/components/Reveal";

const pillars = [
  { name: "Bulk Liquid Storage", testId: "pillar-storage" },
  { name: "Bulk Liquid Handling", testId: "pillar-handling" },
  { name: "Transportation", testId: "pillar-transportation" },
  { name: "Commodity Trading", testId: "pillar-trading" },
];

const About = () => (
  <section id="about" data-testid="about-section" className="scroll-mt-20 bg-ujn-offwhite text-ujn-charcoal">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 py-20 sm:py-28 lg:grid-cols-2 lg:gap-20 lg:px-8">
      <div>
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.28em] text-ujn-medium">ABOUT UJN</p>
          <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-ujn-deep sm:text-3xl lg:text-4xl">
            A PRACTICAL PARTNER FOR BULK LIQUID OPERATIONS
          </h2>
        </Reveal>
        <p className="mt-7 max-w-xl text-base leading-relaxed text-ujn-charcoal/80">
          PT Utama Jaya Nitya is a bulk liquid storage, handling, transportation and commodity trading
          company located in Probolinggo, East Java, Indonesia.
        </p>
        <p className="mt-4 max-w-xl text-base leading-relaxed text-ujn-charcoal/80">
          UJN provides practical storage support for external, overflow, buffer and temporary
          requirements — connecting storage, handling and movement in one operating picture for
          industrial bulk liquid customers.
        </p>

        <div className="mt-10 grid grid-cols-1 gap-px border border-ujn-medium/15 bg-ujn-medium/15 sm:grid-cols-2">
          {pillars.map((p) => (
            <div key={p.testId} data-testid={p.testId} className="flex items-center gap-3 bg-ujn-offwhite px-5 py-4">
              <span className="h-1.5 w-1.5 shrink-0 bg-ujn-medium" />
              <span className="font-mono text-[11px] tracking-[0.14em] text-ujn-deep">{p.name.toUpperCase()}</span>
            </div>
          ))}
        </div>
      </div>

      <Reveal delay={0.15} className="relative">
        <div className="border border-ujn-medium/20">
          <img
            src="/assets/tank-truck.webp"
            alt="UJN storage tanks with tanker truck and pumping equipment at the Probolinggo facility"
            className="h-full w-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="absolute -bottom-5 left-5 border border-ujn-medium/25 bg-ujn-deep px-5 py-4 sm:left-8">
          <p className="font-mono text-[10px] tracking-[0.22em] text-ujn-subtle">OPERATING BASE</p>
          <p className="mt-1 font-heading text-sm font-semibold tracking-wide text-ujn-offwhite">
            PROBOLINGGO, EAST JAVA
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default About;
